import React, { type PropsWithChildren } from 'react';

import invariant from 'tiny-invariant';

import { useOptions } from '../../controllers/options-provider';
import { useNetworkSideNavUserData } from '../../controllers/user-state/persistence/use-network-side-nav-user-data';
import { StoreProviders } from '../../controllers/user-state/store-providers';

export function NetworkStore({ children }: PropsWithChildren) {
	const { networkStorageParams, app } = useOptions();

	invariant(
		networkStorageParams?.activationId &&
			networkStorageParams?.ownerAri &&
			networkStorageParams?.queryRef &&
			networkStorageParams?.siteId,
		'Please provide networkStorageParams when using customization',
	);

	// This is user data for the menu and the sidebar
	const userStoreProps = useNetworkSideNavUserData({ ...networkStorageParams, firstPartyApp: app });

	return <StoreProviders {...userStoreProps}>{children}</StoreProviders>;
}
